export function sendIdentify(userId, traits) {
  if (globalThis.analytics) {
    // eslint-disable-next-line no-undef
    analytics.identify(userId, traits);
  }
}

if (typeof globalThis !== 'undefined') {
  globalThis.unlk = globalThis.unlk || {};
  globalThis.unlk.sendIdentify = sendIdentify;
}
